"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("./compile/index");
var index_2 = require("./run/index");
var index_3 = require("./util/basicTypes/index");
var Eval = /** @class */ (function () {
    function Eval(code) {
        this.abstractSyntaxTree = null;
        this.result = null;
        this.code = code;
    }
    Eval.prototype.compile = function (_context) {
        var _a = index_1.compile(this.code, 0, index_3.variableToBaseType(_context)), root = _a.root, context = _a.context;
        this.abstractSyntaxTree = root;
        this._window = context;
        return root;
    };
    Eval.prototype.run = function () {
        return this.result = index_2.run(this.abstractSyntaxTree, this._window);
    };
    return Eval;
}());
exports.default = Eval;
